export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS

//===========================================store function api=========================================
export const EP_USER_LOGIN = '/api/login'
export const EP_USER_LOGIN_2FA = '/api/login/twofa'
export const EP_USER_SIGNUP = '/api/create/lead'
export const EP_VERIFY_LEAD_OTP = '/api/verify/otp/lead'
export const EP_USER_FORGOT_PASSWORD = '/forgot/password'
export const EP_ADMIN_LOGOUT = '/signout'
export const EP_GENERATE_2FA_QRCODE = '/generate/twofa/qrcode'
export const EP_VERIFY_2FA_QRCODE = '/verify/twofa/secret'
export const EP_DISABLE_2FA_QRCODE = '/disable/twofa'
export const EP_SAVE_USER_NAME = '/add/username'
export const EP_REGISTER_STEP1 = '/create/register/step/one'
export const EP_REGISTER_STEP2 = '/create/register/step/two'
export const EP_REGISTER_STEP3 = '/create/register/step/three'
export const EP_REGISTER_STEP4 = '/create/register/step/four'
export const EP_REGISTER_STEP5 = '/create/register/step/five'
export const EP_SKIP_DOCUMENT_UPLOAD = '/skip/document/upload/step/five'
export const EP_GET_QUESTION_ANSWER = '/get/question_answer'
export const EP_GET_COUNTRIES_LIST = '/get/country/list'
export const EP_GET_CITIES_LIST = '/get/city/list'
export const EP_GET_SUM_SUB_RESPONSE = '/get/user/ipv/details'
export const EP_RESOLVE_DOC_ISSUE = '/resolve/user/ipv/details'
export const EP_LANGUAGE_API = '/update/default/language'
export const EP_SAVE_FIREBASE_TOKEN = '/save/firebase/token'
export const EP_GET_ACCOUNT_PRIORITY_LIST = '/trading/account/priority'
export const EP_SUBMIT_CONSENT = '/zulu/direction/letter'

export const EP_REGISTER_STEP_TMA = '/create/register/step/tma'
export const EP_GET_QUESTION_ANSWER_TMA = '/get/question_answer/tma'
export const EP_TMA_USER_RESPONSE = '/tma/user/response'
//===========================================plugin function api=========================================
export const EP_GET_AUTOCHARTIST_DATA = '/get/autochartist/data'
export const EP_GET_SIGNAL_CENTRE_DATA = '/get/signal-centre/data'
export const EP_GET_ECONOMIC_CALENDER_DATA = '/get/calendar'
export const EP_GET_CURRENT_NEWS = '/get/news'
export const EP_GET_CURRENT_NEWS_DETAIL = '/fxstreet/post/details'
export const EP_GET_COUPON_LIST = '/get/coupon/list'
export const EP_CHECK_COUPON_VALIDITY = '/check/coupon/code'


export const EP_COUPON_PLAN = '/get/plan/coupons'
export const EP_GET_SUB_PLAN_LIST = '/subscription/plan/list'
export const EP_GET_SUB_PLAN_DETAIL = '/subscription/plan/detail'
export const EP_SUB_OPERATION_LINK = '/subscription/operations/link'
export const EP_SUB_OPERATION = '/subscription/operations'
export const EP_CREATE_SUB_TICKET = '/create/subscription'
export const EP_UNSUB_SERVICE = '/end/subscription'

export const EP_GET_VPS_LIST = '/user/server/list'
export const EP_GET_VPS_DETAIL = '/user/server/details'
export const EP_VPS_RESTART = '/vps/server/on'
export const EP_VPS_REBOOT = '/vps/server/reboot'
export const EP_VPS_SHUTDOWN = '/vps/server/off'
export const EP_VPS_CHANGE_PASSWORD = '/vps/server/reset/password'

export const EP_CREATE_ACCOUNT = '/create/account'
export const EP_DEMO_DEPOSIT = '/deposit/demo/account'

export const EP_TRADING_BONUS = '/get/allowed/bonus'
export const EP_BONUS_REQUEST_OTP = '/bonus/otp'
export const EP_BONUS_CHECK_OTP = '/add/bonus'
export const EP_GET_BONUS_LIST = '/get/bonus/list'
export const EP_REMOVE_BONUS = '/remove/bonus'
export const EP_RESEND_EMAIL_LINK_BONUS = '/account/operations/link'

export const EP_TICKET_REQUEST_OTP = '/ticket/request/otp'
export const EP_TICKET_CHECK_OTP = '/ticket/request'
export const EP_GET_TICKET_LIST = '/list/ticket'
export const EP_GET_TICKET_DETAIL = '/ticket/details'
export const EP_TICKET_REPLY = '/create/ticket/thread'
export const EP_GET_TICKET_REASON_LIST = '/get/ticket/reasons'
export const EP_TICKET_RESEND_OTP = '/ticket/request/otp/resend'

export const EP_ACCOUNT_PASSWORD_REQUEST_OTP = '/account/operations'
export const EP_ACCOUNT_PASSWORD_CHECK_OTP = '/account/change/password'
export const EP_ACCOUNT_LEVERAGE_CHECK_OTP = '/change/leverage'
export const EP_INTERNAL_TRANSFER_CHECK_OTP = '/internal/transfer'
export const EP_RUN_ADD_LAST_SELECT_TRADING_ACCOUNT = '/trading/account/history'
export const EP_RESEND_EMAIL_LINK_ACCOUNTS = '/account/operations/link'
export const EP_AMOUNT_CONVERSION_API = '/currency/converter'

export const EP_WITHDRAWAL_REQUEST_OTP = '/withdrawal/request/otp'
export const EP_WITHDRAWAL_CHECK_OTP = '/withdrawal/request'
export const EP_RESEND_EMAIL_LINK = '/withdrawal/request/resend/otp'
export const EP_GET_WITHDRAWAL_METHODS = '/get/withdrawal/methods'
export const EP_GET_WITHDRAWAL_DESC = '/get/withdrawal/desc'

export const EP_GET_USER_CAN_DEPOSIT = '/get/deposit/methods'
export const EP_TRANS_LIMIT_CURRENCY = '/get/deposit/limit'
export const EP_GET_TRANSACTION_STATUS = '/get/transaction/status'

export const EP_GET_TRADING_ACCOUNT_LIST = '/get/trading/account/list'
export const EP_CREATE_API_SUBSCRIPTION = '/create/api/subscription'
export const EP_GET_DEPOSIT_LIST = '/get/deposit/list'
export const EP_CREDIT_CARD_DEPOSIT = '/get/deposit/url'
export const EP_GET_WITHDRAWAL_LIST = '/get/withdrawal/list'
export const EP_GET_TRADING_ACCOUNT_DETAILS = '/get/account/details'

export const EP_GET_PROFIT_CHART_DATA = '/get/profit/data'
export const EP_GET_BALANCE_DATA = '/get/balance/data'
export const EP_GET_EQUITY_DATA = '/get/equity/data'
export const EP_GET_TRADING_DATA = '/get/trading/data'
export const EP_GET_IDENFY_TOKEN = '/get/idenfy/token'

export const EP_ADD_BANK = '/add/bank/account'
export const EP_GET_BANK_LIST = '/get/bank/accounts'

export const EP_GET_USER_PROFILE = '/get/user/profile'
export const EP_GET_USER_REGISTERATION_STEP_DATA = '/get/registration/data'
export const EP_USER_NOTIFICATIONS = '/common/get/notifications'

export const EP_RESET_PASSWORD_FROM_HASH = '/change/via/forgot/password'

export const EP_CHANGE_PASSWORD = '/change/password'


export const EP_GET_HOOPS_DATA = '/get/hoops/data'
export const EP_TUT_COURSE_CATEGORY = '/get/tutorial/course_category'
export const EP_GET_VIDEO_TUTORIAL = '/get/tutorial'

export const EP_UPDATE_FIRST_DEPOSIT = '/update/first/deposit'

export const EP_RISK_WARNING_POPUP = '/create/register/step/risk/warning'

//cancel withdrawal request
export const EP_CANCEL_WITHDRAWAL_REQUEST = '/cancel/withdrawal/request'

export const EP_DELETE_DOC  = '/delete/user/docs'

//Nuvei Api 
export const EP_NUVEI_REQUEST  = '/nuvei/request'









// WEBPACK FOOTER //
// ./src/store/api/endpoints.js